export enum RegistryTypeEnum {
  FORNITORE = 2,
  CLIENTE = 1,
  CLIENTE_FINALE = 3,
}
